import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginForm from "../views/LoginForm.vue";
import EpaycoView from "../views/usuariosExt/EpaycoView.vue";
import TratamienoDatosPersonales from "../views/TratamienoDatosPersonales.vue";
import DatosTarjetasForm from "../views/usuariosExt/DatosTarjetasForm.vue";
import TerminosCondicionesTarjetas from "../views/TerminosCondicionesTarjetas.vue";
import ConectaSabanaHome from "../views/usuariosExt/Home.vue";
import CompraTarjeta from "../views/usuariosExt/CompraTarjeta.vue";
import BloquearTarjeta from "../views/usuariosExt/BloquearTarjeta.vue";
import ReposicionTarjeta from "../views/usuariosExt/ReposicionTarjeta.vue";
import ConsultarSolicitudes from "../views/usuariosExt/ConsultarSolicitudes.vue";

import store from "../store/index.js";

Vue.use(VueRouter);

// Rutas públicas accesibles sin autenticación (usuarios externos)
const PUBLIC_ROUTE_NAMES = [
  "LoginForm",
  "epayco",
  "ForgotPassword",
  "ResetPassword",
  "tratamiento-datos-personales",
  "terminos-condiciones-tarjetas",
  "DatosTarjetasForm",
  "conecta-sabana-home",
  "usuarios-ext-comprar-tarjeta",
  "usuarios-ext-bloquear-tarjeta",
  "usuarios-ext-reposicion-tarjeta",
  "usuarios-ext-consultar-solicitudes",
];

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/LoginForm",
    name: "LoginForm",
    component: LoginForm,
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue"),
  },
  {
    path: "/ResetPassword/:token/:email",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/epayco",
    name: "epayco",
    component: EpaycoView,
  }, 
  {
    path: "/tratamiento-datos-personales",
    name: "tratamiento-datos-personales",
    component: TratamienoDatosPersonales,
  },
  {
    path: "/terminos-condiciones-tarjetas",
    name: "terminos-condiciones-tarjetas",
    component: TerminosCondicionesTarjetas,
  },
  {
    path: "/DatosTarjetasForm",
    name: "DatosTarjetasForm",
    component: DatosTarjetasForm,
  },
  {
    path: "/conecta-sabana",
    name: "conecta-sabana-home",
    component: ConectaSabanaHome,
  },
  {
    path: "/usuarios-ext/comprar-tarjeta",
    name: "usuarios-ext-comprar-tarjeta",
    component: CompraTarjeta,
  },
  {
    path: "/usuarios-ext/bloquear-tarjeta",
    name: "usuarios-ext-bloquear-tarjeta",
    component: BloquearTarjeta,
  },
  {
    path: "/usuarios-ext/reposicion-tarjeta",
    name: "usuarios-ext-reposicion-tarjeta",
    component: ReposicionTarjeta,
  },
  {
    path: "/usuarios-ext/consultar-solicitudes",
    name: "usuarios-ext-consultar-solicitudes",
    component: ConsultarSolicitudes,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isPublicRoute = PUBLIC_ROUTE_NAMES.includes(to.name);
  if (!isPublicRoute && !store.getters.isAuthenticated) {
    return next({ name: "LoginForm" });
  }

  next();
});

export default router;
